(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-looke-journal]').forEach((root) => {
      if (root.dataset.ljReady) return;
      root.dataset.ljReady = 'true';
      const body = root.querySelector('[data-lj-body]');
      const toc = root.querySelector('[data-lj-toc]');
      if (body && toc) {
        const headings = [...body.querySelectorAll('.lj-prose h2')];
        if (headings.length >= 4) {
          const nav = toc.querySelector('nav');
          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = `lj-${root.dataset.articleId}-${index + 1}`;
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent;
            nav.append(link);
          });
          toc.hidden = false;
        }
      }
      const share = root.querySelector('[data-lj-share]');
      if (share && (navigator.share || navigator.clipboard)) {
        share.hidden = false;
        share.addEventListener('click', async () => {
          const canonical = document.querySelector('link[rel="canonical"]')?.href || location.href.split('?')[0];
          const title = root.querySelector('h1')?.textContent || document.title;
          try {
            if (navigator.share) await navigator.share({title, url: canonical});
            else {
              await navigator.clipboard.writeText(canonical);
              root.querySelector('[data-lj-share-status]').textContent = share.dataset.copyLabel;
            }
          } catch (error) {
            if (error.name !== 'AbortError') share.hidden = true;
          }
        });
      }
      root.addEventListener('click', (event) => {
        const link = event.target.closest?.('[data-lj-event]');
        if (!link) return;
        root.dispatchEvent(new CustomEvent('looke:journal', {bubbles: true, detail: {
          action: link.dataset.ljEvent,
          articleId: root.dataset.articleId || '',
          productId: link.closest('[data-product-id]')?.dataset.productId || '',
          destination: link.getAttribute('href')
        }}));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
